import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import CreateForm from "./CreateForm";

const CreateSupplier = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh', overflow: "hidden" }}>
      <Helmet>
				<title>Supplier - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <CreateForm />
      </div>
      </div>
    </>
  );
};

export default CreateSupplier;
